"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBufferFromString = exports.throwIfError = exports.getPath = exports.isNoErrorReturnCode = void 0;
const utils_1 = require("../filecoin/utils");
const isNoErrorReturnCode = (code) => code === 0x9000;
exports.isNoErrorReturnCode = isNoErrorReturnCode;
const getPath = (path) => (path && path.substr(0, 2) !== "m/" ? `m/${path}` : path);
exports.getPath = getPath;
const throwIfError = (r) => {
    if (!(0, exports.isNoErrorReturnCode)(r.returnCode))
        throw new Error(`${r.returnCode} - ${r.errorMessage}`);
};
exports.throwIfError = throwIfError;
const getBufferFromString = (message) => (0, utils_1.isValidHex)(message)
    ? Buffer.from(message, "hex")
    : (0, utils_1.isValidBase64)(message)
        ? Buffer.from(message, "base64")
        : Buffer.from(message);
exports.getBufferFromString = getBufferFromString;
//# sourceMappingURL=utils.js.map